import React from "react";
import PropTypes from "prop-types";

/*
WARNING
Swiper is problematic. Their package.module entry point is ES6, whereas
create-react-app requires import to be ES5. The workaround is to specify
the full import path and point ourselves at their ES5 entry point instead.
This is a bit jank because we're relying on Swiper's internal file
structure, but then we're forced to do that for the CSS anyway, so maybe
it's not a big deal. /shrug
*/
import Swiper from "swiper/dist/js/swiper";
import "swiper/dist/css/swiper.min.css";

/**
 * Wrapper for using swiper.
 * This component does the minimum abstraction of the swiper library.
 * We set up the DOM layout, initialise the swiper instance with the given
 *   options, and then pass the swiper instance to the parent.
 */
export default class SwiperComponent extends React.Component {
  
    static propTypes = {
      classNames: PropTypes.shape({
        container: PropTypes.string,
        wrapper: PropTypes.string,
        slide: PropTypes.string
      }),
      children: PropTypes.arrayOf(PropTypes.node).isRequired,
      options: PropTypes.object
    }
    
    refContainer = (container) => {
      const { options, refSwiper } = this.props;
      this.swiper = new Swiper(container, options);
      if (refSwiper) {
        refSwiper(this.swiper);
      }
    }
    
    render() {
      
      const { classNames } = this.props;
      
      const containerClassNames = [ "swiper-container" ];
      const wrapperClassNames = [ "swiper-wrapper" ];
      const slideClassNames = [ "swiper-slide" ];
      
      if (classNames !== undefined) {
        if (classNames.container !== undefined) {
          containerClassNames.push(classNames.container);
        }
        if (classNames.wrapper !== undefined) {
          wrapperClassNames.push(classNames.wrapper);
        }
        if (classNames.slide !== undefined) {
          slideClassNames.push(classNames.slide);
        }
      }
      
      return (
        <div className={containerClassNames.join(" ")} ref={this.refContainer}>
          <div className={wrapperClassNames.join(" ")}>
            {
              React.Children.map(this.props.children, (slide, index) => (
                <div className={slideClassNames.join(" ")}>
                  {slide}
                </div>
              ))
            }
          </div>
        </div>
      );
      
    }
    
}



// WEBPACK FOOTER //
// ./src/components/Swiper.js